// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SwapRightOutlinedSvg from "@fishx/icons-svg/es/asn/SwapRightOutlined";
import FishxIcon from '../components/FishxIcon';

var SwapRightOutlined = function SwapRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SwapRightOutlinedSvg
  }));
};

SwapRightOutlined.displayName = 'SwapRightOutlined';
export default React.forwardRef(SwapRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SwapRightOutlined.js
// module id = 4209
// module chunks = 0